module.exports = __webpack_public_path__ + "static/stageSet12-39bdd34ca91ecfce75e5082b58c7aacc.jpg";